module.exports = __webpack_public_path__ + "static/media/4-10ft-practice_42x42.3dbfd298.svg";